import { MaterialCommunityIcons } from '@expo/vector-icons';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { useTranslation } from '@/i18n';
import { fontSize, iconSize, lineHeight, spacing, unisonColors } from '@/theme';

const MAX_CONTENT_WIDTH = 560;

interface AiBatonTipProps {
  readonly label: string;
  readonly body: string;
}

const AiBatonTip = ({ label, body }: AiBatonTipProps) => (
  <View style={styles.tipRow}>
    <MaterialCommunityIcons
      color={unisonColors.brandGreenStrong}
      name="check-circle"
      size={iconSize.sm}
      style={styles.tipIcon}
    />
    <Text style={styles.tipText}>
      <Text style={styles.tipLabel}>{label}</Text>
      {body}
    </Text>
  </View>
);

export const AiBatonEmptyState = () => {
  const { t } = useTranslation();

  return (
    <View style={styles.container} testID="ai-baton-empty-state">
      <Text style={styles.title}>{t('aiTasks.emptyTitle')}</Text>
      <Text style={styles.description}>{t('aiTasks.emptyDescription')}</Text>
      <View style={styles.tipsContainer}>
        <AiBatonTip label={t('aiTasks.aiSuggestionsLabel')} body={t('aiTasks.aiSuggestionsBody')} />
        <AiBatonTip
          label={t('aiTasks.pushNotificationsLabel')}
          body={t('aiTasks.pushNotificationsBody')}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    // Caps the measure on wide screens so the centred text and the full-width
    // tips read as one column instead of drifting apart.
    width: '100%',
    maxWidth: MAX_CONTENT_WIDTH,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing[4],
  },
  title: {
    textAlign: 'center',
    fontSize: fontSize.xxl,
    lineHeight: lineHeight.xxl,
    color: unisonColors.textNdPrimary,
  },
  description: {
    textAlign: 'center',
    fontSize: fontSize.sm,
    lineHeight: lineHeight.sm,
    color: unisonColors.textNdSecondary,
  },
  tipsContainer: {
    width: '100%',
    gap: spacing[2],
  },
  tipRow: {
    flexDirection: 'row',
    gap: spacing[2],
  },
  tipIcon: {
    marginTop: 2,
  },
  tipText: {
    flex: 1,
    fontSize: fontSize.sm,
    lineHeight: lineHeight.sm,
    color: unisonColors.textNdSecondary,
  },
  tipLabel: {
    fontWeight: '700',
  },
});
